module.exports = __webpack_public_path__ + "static/images/callout_3.ade34196fc654fef8a75719870e9cd4d.jpg";